/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Albumina List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AlbuminaListView';

export const mapStateToPropsAlbuminaList = mapStateToProps;
export const mapDispatchToPropsAlbuminaList = mapDispatchToProps;

export default connect(
  mapStateToPropsAlbuminaList,
  mapDispatchToPropsAlbuminaList
)(View);
